import React from 'react';
import { Block, ContentsListBlockContent } from '../types';
import { ControlPanelToggleButton } from '../components/control-panel/toggle-button';
import {
  NeueHorizontalAlignCenterStrongIcon,
  NeueHorizontalAlignLeftStrongIcon,
  NeueHorizontalAlignRightStrongIcon,
} from 'src/monet/icons';
import { NeueToggleComponent } from '../components/toggle/component';

export type ContentsListAlignmentTypes = 'left' | 'center' | 'right';

export const ContentsListControlPanelContent = ({
  block,
  onAlignmentChange,
  onToggleIndex,
}: {
  block: Block;
  onAlignmentChange: (alignment: ContentsListAlignmentTypes) => void;
  onToggleIndex: (value: boolean) => void;
}) => {
  const content = block.content as ContentsListBlockContent;
  return (
    <div className='flex flex-col gap-4'>
      <span className='text-neue-journey-small -mt-3'>
        Content is automagically generated based on the section titles
      </span>
      <div className='flex gap-2'>
        <ControlPanelToggleButton
          selected={content.alignment === 'left'}
          onClick={() => {
            if (content.alignment !== 'left') {
              onAlignmentChange('left');
            }
          }}
          icon={<NeueHorizontalAlignLeftStrongIcon />}
        />
        <ControlPanelToggleButton
          selected={content.alignment === 'center'}
          onClick={() => {
            if (content.alignment !== 'center') {
              onAlignmentChange('center');
            }
          }}
          icon={<NeueHorizontalAlignCenterStrongIcon />}
        />
        <ControlPanelToggleButton
          selected={content.alignment === 'right'}
          onClick={() => {
            if (content.alignment !== 'right') {
              onAlignmentChange('right');
            }
          }}
          icon={<NeueHorizontalAlignRightStrongIcon />}
        />
      </div>
      <div className='flex items-center gap-2 p-1'>
        <NeueToggleComponent checked={content.enableIndex} onChange={onToggleIndex} label='Show numbers' />
      </div>
    </div>
  );
};
